import {put,takeLatest,call} from 'redux-saga/effects'
import * as venueService from "../../../services/venueService"
import {
    DELETE_VENUE,
    DELETE_VENUE_SUCCESS,
    DELETE_VENUE_ERROR
}
    from "../../actions/venue"

function* deleteVenueSaga(action) {
    try {
        yield call(venueService.DeleteVenue,action.payload)
        yield put({
            type: DELETE_VENUE_SUCCESS,
            payload: action.payload.uid
        })

    } catch(error) {
        yield put({
            type: DELETE_VENUE_ERROR,error: error.data
        })
    }
}

export function* deleteVenueSagaWatcher() {
    yield takeLatest(DELETE_VENUE,deleteVenueSaga)
}